import { fetch } from 'wix-fetch'
const tenantId = "4de73381-1017-4b46-b0b7-9dae17fe22c0"

export const infoLog = async (args) => log(args, "INFO")
export const errorLog = async (err) => log(err, "ERROR")

export async function log(args, severity) {
    const telemetryLog = actionLog(args, severity)
    await fetch("https://frog.wix.com/wct", {
        body: JSON.stringify(telemetryLog),
        headers: { "Content-Type": "application/json" },
        method: "post",
    })
}

function actionLog(args, severity) {
    return {
        "jsonPayload": args,
        "labels": {
            tenantId
        },
        severity,
        "timestamp": new Date().toISOString(),
    }
}